module.exports = __webpack_public_path__ + "static/media/slide2.85ec6070.jpg";